/**
 * Giulio dice qualcosa di diverso in base alla pagina.
 * Hook: ritorna la frase contestuale per il bottone flottante o altri contesti.
 */
import { useLocation } from 'react-router-dom';

const QUOTES = {
  '/':             ['Benvenuto in AgriNexus!', 'Hai visto quanti terreni?', 'Dai, iniziamo insieme!'],
  '/esplora':      ['Cerchi un terreno? Chiedimi!', 'Serve una mano a filtrare?', 'Posso aiutarti a scegliere.'],
  '/mappa':        ['Un click sul pin per i dettagli!', 'Esplora la mappa, io ti guido.', 'Trova il tuo terreno ideale!'],
  '/partite':      ['Oggi è giornata di raccolto!', 'Prodotti freschi dai nostri agricoltori.', 'Chiedimi dove vendere!'],
  '/pubblica':     ['Ti aiuto a pubblicare al meglio!', 'Hai bisogno della descrizione? Chiedimi!', 'Compila con calma, io sono qui.'],
  '/partite/pubblica': ['Pubblica la tua partita in 3 minuti!', 'Vuoi la stima quintali? Dai un\'occhiata!', 'Scrivi tutto, poi ti aiuto io.'],
  '/stima-quintali': ['Scopri quanti quintali hai!', 'Carica le foto, faccio io il resto.', 'Pronto per l\'analisi AI!'],
  '/suggeriti':    ['Guarda cosa ho trovato per te!', 'Imposta meglio le preferenze.', 'Posso suggerirti qualcosa?'],
  '/preferenze':   ['Più dici, più trovo!', 'Perfeziona le preferenze.', 'Dimmi cosa ti serve!'],
  '/dashboard':    ['Bentornato!', 'Tutto sotto controllo?', 'Giornata produttiva?'],
  '/messaggi':     ['Rispondi veloce, il tempo è prezioso!', 'Nuove conversazioni?', 'Trattative in corso?'],
  '/chi-siamo':    ['Siamo qui per voi.', 'La nostra storia è anche la vostra.'],
  '/contatti':     ['Scrivi, ti rispondo subito!', 'Siamo a tua disposizione.'],
};

const DEFAULT = ['Ciao! Sono Giulio ✨', 'Posso aiutarti?', 'Chiedi pure, sono qui!'];

export function useGiulioQuote() {
  const loc = useLocation();
  const path = loc.pathname;
  // Match esatto, poi prefisso più lungo
  let quotes = QUOTES[path];
  if (!quotes) {
    const keys = Object.keys(QUOTES).sort((a, b) => b.length - a.length);
    const key = keys.find(k => path.startsWith(k) && k !== '/');
    quotes = QUOTES[key];
  }
  if (!quotes) quotes = DEFAULT;
  // Pseudo-random stabile per sessione+path (non cambia a ogni re-render)
  const seed = (sessionStorage.getItem('giulio.seed') || Math.random().toString()).toString();
  if (!sessionStorage.getItem('giulio.seed')) {
    try { sessionStorage.setItem('giulio.seed', seed); } catch {}
  }
  const hash = (path + seed).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return quotes[hash % quotes.length];
}
